import * as XLSX from 'xlsx-js-style';
import { saveAs } from 'file-saver';
import { dateFormat } from '../formatDate';

export const exportToExcelTransaction = async (data, startDate, endDate) => {
  let mappedData = [];
  data.forEach(item => {
    if (item.transaction_products.length > 0) {
      item.transaction_products.forEach(product => {
        let price_after_discount = Number(product.discount?.price_after_discount || 0);
        let discount_price = Number(product.discount?.discount_price || 0);
        let qty = Number(product.qty);
        let discount_percent = Number(product.discount?.discount_percent || 0);
        let discount_percent_2 = Number(product.discount?.discount_percent_2 || 0);
        let subtotal = Number(product.subtotal);
        let price_normal = price_after_discount + discount_price;
        let voucherNum = item.voucher ? Number(item.voucher.discount_price) : Number(item.voucher_price || 0);

        mappedData.push({
          'Kode Transaksi': item.transaction_code,
          'Tanggal': dateFormat(item.created_at),
          'Nama Member': item.customer?.name || '-',
          'Outlet': item.outlet.outlet_name,
          'Gudang': product.warehouse?.warehouse_name || '-',
          'Nama Barang': product.product.product_name,
          'Harga Normal': price_normal,
          'Diskon 1 (%)': discount_percent,
          'Diskon 2 (%)': discount_percent_2,
          'Harga Setelah Diskon': price_after_discount,
          'Qty': qty,
          'Sub Total': subtotal,
          'Voucher': voucherNum,
          'Point': item.point?.point || 0,
          'Tukar Point': item.point_redeem || 0,
          'Pembayaran': item.payment_method === 'tunai' ? 'TUNAI' : item.device_payment
        });
      });
    }
  });

  const totalQty = mappedData.reduce((acc, item) => acc + Number(item['Qty']), 0);
  const totalSubTotal = mappedData.reduce((acc, item) => acc + Number(item['Sub Total']), 0);
  const totalPoint = mappedData.reduce((acc, item) => acc + Number(item['Point']), 0);
  const totalPointRedeem = mappedData.reduce((acc, item) => acc + Number(item['Tukar Point']), 0);

  const ws = XLSX.utils.json_to_sheet(mappedData, { skipHeader: false, origin: 'A4' });

  // Judul dan Periode
  XLSX.utils.sheet_add_aoa(ws, [
    ['Laporan Transaksi'],
    [`Periode: ${startDate} s/d ${endDate}`]
  ], { origin: 'A1' });

  // Merge dan styling judul
  ws['!merges'] = [
    { s: { r: 0, c: 0 }, e: { r: 0, c: 15 } },
    { s: { r: 1, c: 0 }, e: { r: 1, c: 15 } }
  ];

  ws['A1'].s = {
    font: { bold: true, sz: 14 },
    alignment: { horizontal: 'center' }
  };

  ws['A2'].s = {
    font: { sz: 12 },
    alignment: { horizontal: 'center' }
  };

  // Styling header (row 4)
  const headerStyle = {
    font: { bold: true },
    fill: { fgColor: { rgb: 'E2EFDA' } },
    border: {
      top: { style: 'thin' },
      bottom: { style: 'thin' },
      left: { style: 'thin' },
      right: { style: 'thin' }
    },
    alignment: { horizontal: 'center', vertical: 'center' }
  };

  const keys = Object.keys(mappedData[0]);
  keys.forEach((_, idx) => {
    const cell = ws[XLSX.utils.encode_cell({ r: 3, c: idx })];
    if (cell) cell.s = headerStyle;
  });

  // Styling all data rows
  for (let r = 4; r < mappedData.length + 4; r++) {
    for (let c = 0; c < keys.length; c++) {
      const cell = ws[XLSX.utils.encode_cell({ r, c })];
      if (cell) cell.s = {
        border: {
          top: { style: 'thin' },
          bottom: { style: 'thin' },
          left: { style: 'thin' },
          right: { style: 'thin' }
        },
        alignment: { horizontal: 'left', vertical: 'center' }
      };
    }
  }

  // Menambahkan total
  XLSX.utils.sheet_add_aoa(ws, [[
    '', '', '', '', '', '', '', '', '', '', totalQty, totalSubTotal, '', totalPoint, totalPointRedeem
  ]], { origin: -1 });

  // Column width
  ws['!cols'] = [
  { wch: 25 },  // Kode Transaksi
  { wch: 25 },  // Tanggal
  { wch: 30 },  // Nama Member
  { wch: 30 },  // Outlet
  { wch: 30 },  // Gudang
  { wch: 50 },  // Nama Barang
  { wch: 14 },  // Harga Normal
  { wch: 14 },  // Diskon 1 (%)
  { wch: 14 },  // Diskon 2 (%)
  { wch: 22 },  // Harga Setelah Diskon
  { wch: 5 },   // Qty
  { wch: 11 },  // Sub Total
  { wch: 9 },   // Voucher
  { wch: 7 },   // Point
  { wch: 13 },  // Tukar Point
  { wch: 12 }   // Pembayaran
]


  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Laporan');
  const buf = XLSX.write(wb, { type: 'array', bookType: 'xlsx' });
  saveAs(new Blob([buf], { type: 'application/octet-stream' }), `Laporan_Transaksi_${startDate}_sd_${endDate}.xlsx`);
};
